import {Button, Modal, theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  isOpen: boolean;
  toggleDialog(readyToSubmit: boolean): any;
  text: any;
}

const PersonalDataDialog: React.FC<IProps> = (props) => {
  const {isOpen, toggleDialog, text} = props;
  const {token}: any = theme.useToken();

  return (
    <Modal
      // Unmount content on close, as the old MUI Dialog did, so each open starts fresh.
      destroyOnHidden
      open={isOpen}
      closable={false}
      footer={[
        <Button key="true" onClick={() => toggleDialog(false)} style={{width: '25%'}}>
          {text.button_text_true}
        </Button>,
        <Button
          key="false"
          type="primary"
          onClick={() => toggleDialog(true)}
          style={{width: '25%'}}>
          {text.button_text_false}
        </Button>,
      ]}>
      <Typography.Title level={3} style={{color: token.colorPrimary, paddingTop: 32}}>
        {text.heading}
      </Typography.Title>
      <Typography.Text style={{display: 'block', paddingBottom: 32}}>
        {text.description}
      </Typography.Text>
    </Modal>
  );
};

export default PersonalDataDialog;
